<template
  ><!-- 店铺礼包千人千面 -->
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <img class="pointer" @click="returnBack()" src="@/assets/thdImg/pages/back.svg" alt="" />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div :class="{ formBox: localStep != 0 }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStep">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStep == 0">
        <div class="tishi tipBg">
          <span class="desc" style="color:#000;">
            <i class="el-alert__icon el-icon-info"></i>
            官方规则：店铺礼包和开卡礼包为同类型活动，每个店铺只能存在1个进行中礼包活动(并与其他系统同步）且不支持预创建，所以店铺礼包在哪里创建的也只能在哪里关闭哦。
          </span>
        </div>
        <!-- 导航切换 -->
        <div class="activeEdit_bottom" v-loading="loading">
          <div class="template">
            <div style="width: 82px;padding-top: 5px;">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in navList"
                :key="item.id"
                :class="{ activeTem: tabActive == index }"
                v-show="item.isVisible"
                @click="handleNav(item, index)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div class="temImg_content" @click="handleOpen()" style="border: 1px solid rgba(123,97,255,0.15);">
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="@/assets/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div class="temImg_content_wz" style="background: rgba(123, 97, 255, 0.05);"></div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow" style="height:432px;border-radius: 8px;" @click="handleOpen()">
                <div class="temImg_content_bgshadow_codeDZ">
                  <img style="width:100%" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png" alt="">
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div class="temImg" v-for="item in giftList" :key="item.id">
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img style="width:100%;max-height: 380px;" :src="item.templateExampleUrl" alt="" />
                  <img v-if="item.expirationType" class="temImg_content_img_free" src="@/assets/thdImg/common/free.svg" alt="" srcset="" />
                  <div v-if="item.expirationType" class="temImg_content_img_time">倒计时：{{ item.days }}</div>
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.templateName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <div class="temImg_content_bgshadow">
                <div class="temImg_content_bgshadow_code qrCodeIMG" id="qrCodeIMG1" ref="qrCodeIMG1" style="margin-top: 80px;"></div>
                <div class="temImg_content_bgshadow_codeDesc">手机扫码预览模板</div>
                <div class="temImg_content_bgshadow_jx">
                  <div>奖项：最多支持{{ item.awardNumLimit }}个奖品</div>
                  <div>
                    （{{
                      item.prizeType
                        .replace("1", "店铺积分")
                        .replace("2", "京豆")
                        .replace("3", "京券")
                        .replace("4", "东券")
                        .replace(/,/g, "、")
                    }}）
                  </div>
                </div>
                <div class="temImg_content_bgshadow_btn pointer" @click="nextStepKai(item)">使用此模板</div>
              </div>
            </div>
          </div>
          <br />
          <!-- 分页 -->
          <!-- <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageData.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="pageData.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            style="text-align: right;margin-top: 20px;"
          >
          </el-pagination> -->
        </div>
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep" v-if="localStep != 0">
        <!-- 店铺礼包千人千面 -->
        <div class="card-point tipBg">
          <div class="card-rule">官方规则：</div>
          <div class="card-connet">
            <p>1、<span style="color:#000;font-weight: bold;">活动生效时间：</span>POP和自营15分钟后生效。</p>
            <p>2、FCS商家创建礼包时，暂时无法选择优惠券礼品，请您知晓，避免造成客诉！</p>
          </div>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="backgroundForm" label-width="150px">
          <div class="newsInfo">基本信息</div>
          <el-form-item label="活动名称:" required>
            <!-- prop="activityName" 活动名称 -->
            <el-input v-model="ruleForm.activityName" :disabled="isStart" maxlength="15" show-word-limit placeholder="请填入活动名称" style="width: 400px"></el-input>
          </el-form-item>

          <el-form-item label="活动时间:" required>
            <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
            <div class="my_select_time">
              <!-- <el-date-picker
                v-model="activityTimeValue"
                type="datetimerange"
                class="rangeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                @change="activityTimeChange"
                style="width: 400px; font-size: 12px"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="activityTimeValue = []"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" /> -->
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.activityStartTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
                :clearable="false"
                :disabled="isStart"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.activityEndTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValueEnd"
                :default-time="defaultTime"
                :clearable="false"
                :disabled="activityData.isStart"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" v-if="!isStart" @click="clearTime"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #7B61FF">{{ timeDay }}</span> 天 <span style="color: #7B61FF">{{ timeOut }}</span> 小时
              <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item label="关注店铺:">
            <el-radio v-model="ruleForm.requestFollow" label="1" :disabled="isStart">是</el-radio>
            <el-radio v-model="ruleForm.requestFollow" label="2" :disabled="isStart">否</el-radio>
            <el-tooltip class="item" effect="light" content="勾选关注后参加活动的同时关注店铺" placement="bottom">
              <el-button type="text" style="margin-left: -20px;width:35px">
                <i class="el-icon-question" style="color: #ccc;"></i>
              </el-button>
            </el-tooltip>
          </el-form-item>
          <div class="newsInfo">活动条件</div>
          <el-form-item label="加购商品:" prop="exposure" class="zindexBox">
            <el-radio-group @change="exposureChange" v-model="ruleForm.radio">
              <el-radio :label="0">不限制</el-radio>
              <el-radio :label="1">加购商品</el-radio>
            </el-radio-group>
            <el-button
              class="zindexBox"
              :style="{ width: itemListFor.length > 0 ? '110px' : '60px', margin: ' 0 0px 0 15px' }"
              @click="exposureProducts"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{ itemListFor.length != "" ? "+添加" + "(" + itemListFor.length + "/20" + ")" : "+添加" }}
            </el-button>
            <el-tooltip class="item" effect="light" content="勾选后领取礼包直接加购指定商品，最多添加20个sku" placement="bottom">
              <el-button type="text" style="width:35px">
                <i class="el-icon-question" style="color: #ccc;"></i>
              </el-button>
            </el-tooltip>
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;"
              filter=".unmover"
            >
              <transition-group type="transition">
                <div v-for="(item, index) in mainImagelist" :key="item.skuId" style="display: inline-block; position: relative" class="show_upImg2">
                  <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img src="@/assets/thdImg/pages/delet.svg" @click.stop="delec(index)" class="delectIcom" />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>
          <div class="newsInfo">礼包设置</div>
          <el-form-item label="投放场景:" required
            >可为不同匹配人群设置不同场景内容，<span style="color:#7B61FF">勾选后场景生效（至少1个）</span>
            <div>未勾选的场景其设置的数据不会保存</div>
            </el-form-item
          >
          <div class="crowd">
            <div class="crowd-point zindexBox">
              <el-tabs v-model="activeName" type="card" @tab-click="handleClickTabs">
                <el-tab-pane :disabled="isStart" v-for="(item, index) in personLab" :key="item.labelId" :name="`index${index}`">
                  <div slot="label" class="crowd-point-rq" :class="{ crowdAction: index == crowIndex }" @click="handleCrow(item, index)">
                    <el-checkbox v-model="scenariobCj[index].checkThrong" :disabled="isStart"></el-checkbox>
                    {{ item.labelName }}
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div style="border: 1px solid #f0f0f0;margin-left: 8px;">
              <div class="crowd-tab">
                <div class="crowd-tab-head">
                  <div class="crowd-tab-name">人群名称</div>
                  <div class="crowd-tab-sm" style="color:#000">人群说明</div>
                </div>
                <div class="crowd-tab-middle" v-for="item in personLabCrow" :key="item.labelId">
                  <div class="crowd-tab-name nameAlign">
                    <el-tooltip class="item" effect="light" :content="item.labelName" placement="top-start">
                      <el-button class="overHiddle">{{ item.labelName }}</el-button>
                    </el-tooltip>
                  </div>

                  <div class="crowd-tab-sm" :class="{ descbox: item.labelVal }">
                    {{ item.labelDesc }}
                    <div class="dx">
                      <el-checkbox style="display: inline-block" v-if="item.labelName !== '店铺会员'" :disabled="isStart" v-model="scenariobCheckAll[crowIndex].checkThrong" @change="handleCheckedChange"
                        >全选</el-checkbox
                      >
                      <el-checkbox-group
                        @change="handleChang"
                        style="display: inline-block;"
                        v-model="scenariobRidCheck[crowIndex].checkThrong"
                        :disabled="isStart"
                      >
                        <div v-for="item1 in item.labelVal"  :key="item1.level" style="display: inline-block;">
                            <el-checkbox  v-if='item1.level == -1' :label="item1.level"  :disabled="openClick == 1" > {{
                              item1.desc
                            }}</el-checkbox>
                            <el-checkbox  v-else :label="item1.level"  :disabled="openClick == 2" >{{
                              item1.desc
                            }}</el-checkbox>
                         </div>

                        <!-- <el-checkbox v-for="item1 in item.labelVal" :label="item1.level" :key="item1.level">{{ item1.desc }}</el-checkbox> -->
                      </el-checkbox-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-form-item label="发送人数:" required>
            <el-input v-model="sceneList[crowIndex].sendCount" :disabled="isStart" @input="sceneList[crowIndex].sendCount = getNumberData(1, $event, 0, 1)" show-word-limit placeholder="请输入" style="width: 140px">
            </el-input>
            &nbsp;人
            <el-tooltip class="item" effect="light" content="奖品发放总人数设置" placement="bottom">
              <el-button type="text" style="margin-left: 6px;width: 35px;">
                <i class="el-icon-question" style="color: #ccc;"></i>
              </el-button>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="礼包样式:" style="position: relative;" required>
            <!-- <span>当前样式只能设置{{ sceneList[crowIndex].templateNum }}个奖项,勾选后则选中该奖品。</span> -->
            <span>当前样式只能设置{{ sceneList[crowIndex].awardNumLimit }}个奖项,勾选后则选中该奖品。</span>
            <!--Tag:礼包模板配置优化 wk -->
            <template>
              <div class="shopSet">
                <div class="shopSet-left">
                  <div class="shopSetLeft-connet">
                    <!-- <div class="inner" v-if="sceneList[crowIndex].jfshow"> -->
                    <div class="inner">
                      <div class="innerTap">
                        <div class="logoImg">
                          <el-checkbox v-model="sceneList[crowIndex].jfcheck" :disabled="isStart"></el-checkbox>
                        </div>
                        <div class="innerTap-name">店铺积分</div>
                      </div>
                      <div class="innerTip">
                        <div class="innerTip-content">
                          <div class="innerTip-content-name">每人店铺积分：</div>
                          <el-input
                            style="width:140px"
                            placeholder="输入积分"
                            @input.native="sceneList[crowIndex].jfprice = scenariobCheckputn($event)"
                            v-model="sceneList[crowIndex].jfprice"
                            :disabled="isStart"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                    <div class="inner" v-if="sceneList[crowIndex].jdshow">
                      <div class="innerTap">
                        <div class="logoImg">
                          <el-checkbox v-model="sceneList[crowIndex].jdcheck" :disabled="isStart"></el-checkbox>
                        </div>
                        <div class="innerTap-name">京豆</div>
                      </div>
                      <div class="innerTip">
                        <div class="innerTip-content">
                          <div class="innerTip-content-name">每人京豆数量：</div>
                          <el-input
                            style="width:140px"
                            placeholder="输入京豆"
                            @input.native="sceneList[crowIndex].jdprice = scenariobCheckputn($event)"
                            v-model="sceneList[crowIndex].jdprice"
                            :disabled="isStart"
                          ></el-input>
                        </div>
                        <div class="innerTip-content">
                          当前账户余额{{ jingdouAccountNum }}京豆，预计冻结{{ sceneList[crowIndex].sendCount * sceneList[crowIndex].jdprice }}京豆。<a
                            style="display:inline-flex;width:82px;min-width: 82px"
                            @click="jumpJingduo"
                            >去充值京豆></a
                          >
                        </div>
                        <div class="innerTip-content zhuyi" style="line-height: 20px;color:red">
                          注：活动创建成功后，京豆将被冻结，如未发放完需到活动时间结束时才会解冻返还
                        </div>
                      </div>
                    </div>
                    <div class="inner" v-if="sceneList[crowIndex].dqshow">
                      <div class="innerTap">
                        <div class="logoImg">
                          <el-checkbox v-model="sceneList[crowIndex].dqcheck" :disabled="isStart"></el-checkbox>
                        </div>
                        <div class="innerTap-name">
                          东券
                          <el-tooltip
                            class="item"
                            effect="light"
                            content="属于店铺级、有门槛优惠券，单笔订单只能使用一张东券，即东券与东券不能叠加。"
                            placement="top"
                          >
                            <el-button type="text" style="margin-left: -2px;margin-top: 2px;width: 35px;">
                              <i class="el-icon-question" style="color: #ccc;"></i>
                            </el-button>
                          </el-tooltip>
                        </div>
                      </div>
                      <div class="innerTip">
                        <template v-if="venderType">
                          <div class="innerTip-content">
                            <div class="innerTip-content-name">优惠券key：</div>
                            <el-input :disabled="isStart" style="width:140px;margin-right: 20px;" placeholder="请输入" v-model="sceneList[crowIndex].dqkey"></el-input>
                            <!-- <el-button type="primary" @click="handleInspect('1')">检测可用性</el-button> -->
                          </div>
                          <!-- <div class="innerTip-content zhuyi notes" style="color:red">
                          注：自营商家可自己申请或找采销申请优惠券，复制Key
                        </div> -->
                        </template>
                        <template v-if="!venderType">
                          <div class="innerTip-content">
                            <div class="innerTip-content-name">东券面额：</div>
                            <div class="innerTip-content-input">
                              <el-input
                                style="width:140px"
                                placeholder="请输入"
                                @input.native="sceneList[crowIndex].dqprice = scenariobCheckputn($event)"
                                v-model="sceneList[crowIndex].dqprice"
                                :disabled="isStart"
                              ></el-input
                              ><span>元</span>
                            </div>
                          </div>
                          <div class="innerTip-content">
                            <div class="innerTip-content-name">订单满：</div>
                            <div class="innerTip-content-input">
                              <el-input
                                style="width:140px"
                                placeholder="请输入"
                                @input.native="sceneList[crowIndex].dqquota = scenariobCheckputn($event)"
                                v-model="sceneList[crowIndex].dqquota"
                                :disabled="isStart"
                              ></el-input
                              ><span>元可使用</span>
                            </div>
                          </div>
                          <div class="innerTip-content">
                            <div class="innerTip-content-name">领取后有效期：</div>
                            <div class="innerTip-content-input">
                              <el-input
                                style="width:140px"
                                placeholder="请输入"
                                @input.native="sceneList[crowIndex].dqday = scenariobCheckputn($event, '1')"
                                v-model="sceneList[crowIndex].dqday"
                                :disabled="isStart"
                              ></el-input>
                              <span>天</span>
                            </div>
                          </div>
                        </template>
                        <template v-if="venderType">
                          <div class="innerTip-content zhuyi notes" style="color:red">
                            注：自营商家可自己申请或找采销申请优惠券，复制Key
                          </div>
                        </template>
                      </div>
                    </div>
                    <div class="inner" v-if="false">
                      <div class="innerTap">
                        <div class="logoImg">
                          <el-checkbox v-model="sceneList[crowIndex].jqcheck" :disabled="isStart"></el-checkbox>
                        </div>
                        <div class="innerTap-name">
                          京券
                          <el-tooltip
                            class="item"
                            effect="light"
                            content="京券：属于店铺级、无门槛优惠券，单笔订单京券与京券可叠加使用，京券与东券不能叠加使用。"
                            placement="top"
                          >
                            <el-button type="text" style="margin-left: -2px;margin-top: 2px;width: 35px;">
                              <i class="el-icon-question" style="color: #ccc;"></i>
                            </el-button>
                          </el-tooltip>
                        </div>
                      </div>
                      <div class="innerTip">
                        <div class="innerTip-content">
                          <div class="innerTip-content-name">东券面额：</div>
                          <div class="innerTip-content-input">
                            <el-input
                              style="width:140px"
                              placeholder="请输入"
                              @input.native="sceneList[crowIndex].jqprice = scenariobCheckputn($event)"
                              v-model="sceneList[crowIndex].jqprice"
                              :disabled="isStart"
                            ></el-input>
                            <span>元</span>
                          </div>
                        </div>
                        <div class="innerTip-content">
                          <div class="innerTip-content-name">订单满：</div>
                          <div class="innerTip-content-input">
                            <el-input
                              style="width:140px"
                              placeholder="请输入"
                              @input.native="sceneList[crowIndex].jqquota = scenariobCheckputn($event)"
                              v-model="sceneList[crowIndex].jqquota"
                              :disabled="isStart"
                            ></el-input>
                            <span>元可使用</span>
                          </div>
                        </div>
                        <div class="innerTip-content">
                          <div class="innerTip-content-name">领取后有效期：</div>
                          <div class="innerTip-content-input">
                            <el-input
                              style="width:140px"
                              placeholder="请输入"
                              @input.native="sceneList[crowIndex].jqday = scenariobCheckputn($event, '1')"
                              v-model="sceneList[crowIndex].jqday"
                              :disabled="isStart"
                            ></el-input>
                            <span>天</span>
                          </div>
                        </div>
                        <template v-if="venderType">
                          <div class="innerTip-content">
                            <div class="innerTip-content-name">优惠券key：</div>
                            <el-input style="width:140px;margin-right: 20px;" :disabled="isStart" v-model="sceneList[crowIndex].jqkey"></el-input>
                            <!-- <el-button type="primary" @click="handleInspect('2')">检测可用性</el-button> -->
                          </div>
                          <div class="innerTip-content zhuyi notes">
                            注：自营商家可自己申请或找采销申请优惠券，复制Key
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>

                  <!-- <el-form-item label-width="150px" style="margin: 40px 0 0px -150px;" label="礼包确认按钮文案:" required>
                  <el-input
                    v-model="sceneList[crowIndex].buttonText"
                    maxlength="5"
                    show-word-limit
                    placeholder="礼包确认按钮文案"
                    style="width: 200px"
                  ></el-input>
                </el-form-item> -->
                  <el-form-item label-width="150px" style="margin: 40px 0 0px -150px;" label="跳转链接:">
                    <!-- prop="activityName" 活动名称 -->
                    <el-input
                      type="textarea"
                      class="textareabox"
                      placeholder="请输入链接"
                      style="width: 336px"
                      resize="none"
                      v-model="sceneList[crowIndex].jumpLink"
                      :disabled="isStart"
                    ></el-input>
                    <div class="zhuyi" style="line-height: 20px;color:red;margin-left: 0px;margin-top: 5px;">
                      注：用户点击礼包跳转的落地页链接，如果不设置，则点击礼包默认关闭弹窗
                    </div>
                  </el-form-item>
                </div>
                <div class="shopSet-right">
                  <!-- <div>
                    <el-button
                      slot="reference"
                      @click="giftPopup = true"
                      type="text"
                      style="width:105px;background: #7B61FF;color:#fff;margin-top: 5px;"
                      :disabled="isStart"
                      >重新选择模板</el-button
                    >
                  </div> -->
                  <div class="wrapperBg" style="margin-top:25px;width: 235px;height: 419px;position: relative;">
                    <img class="giftImg" v-if="sceneList[crowIndex].customPicUrl" :src="sceneList[crowIndex].customPicUrl" :style="{ width: '210px', height: 788 / 3 + 'px' }" />
                    <div class="giftContent" v-if="sceneList[crowIndex].giftPrizeType != 2">
                      <div v-if="sceneList[crowIndex].dqshow && sceneList[crowIndex].dqcheck">{{ sceneList[crowIndex].dqprice || 0 }}东券</div>
                      <div v-if="false">{{ sceneList[crowIndex].jqprice || 0 }}京券</div>
                      <div v-if="sceneList[crowIndex].jdshow && sceneList[crowIndex].jdcheck">{{ sceneList[crowIndex].jdprice || 0 }}京豆</div>
                      <div v-if="sceneList[crowIndex].jfshow && sceneList[crowIndex].jfcheck">{{ sceneList[crowIndex].jfprice || 0 }}店铺积分</div>
                    </div>
                    <span class="giftBottom">{{ sceneList[crowIndex].buttonText }}</span>
                  </div>
                  <div class="shopSet-right-btn">
                    <el-button slot="reference" type="primary" style="margin-right: 8px;"  @click="giftPopup = true" :disabled="isStart">更换模板</el-button>
                    <el-upload
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="beforeUploadUrl"
                      :on-success="handleUploadUrl"
                      :disabled="isStart"
                    >
                      <el-button type="primary" style="margin-right: 8px;" :disabled="isStart">更换图片</el-button>
                    </el-upload>
                    <el-button type="primary" :disabled="isStart" @click="resetUrl">重置图片</el-button>
                  </div>
                  <div class="shopSet-right-tips">
                    <div>不建议自行更换活动图片，有需求可联系客服进行定制上传</div>
                    <div>图片尺寸：推荐 宽度630px  高度788px</div>
                    <div>图片大小：不超过1M，支持JPG、JPEG、GIF、PNG</div>
                  </div>
                </div>
              </div>
            </template>
          </el-form-item>
          <actInfoSetting :valueRow="valueRow" :activityData="activityData" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition"/>

          <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStep != 0">
      <el-button v-show="!itemId" class="returnBtn" size="medium" @click="clickLocalStep()">{{
        backgroundOpacity ? "返回列表" : "返回上一步"
      }}</el-button>
      <el-button class="returnBtn createBtn" @click="saveDraft" v-if="hasDraftBtn">存为草稿</el-button>
      <template v-if="!backgroundOpacity">
        <el-button v-show="!itemId" v-if="isSave" class="keepBtn" type="primary" size="medium" @click="saveEdit" v-preventReClick
          >保存并完成设置</el-button
        >
      </template>
      <el-button v-show="itemId" class="returnBtn" size="medium" @click="cancelEdit">取消</el-button>
      <el-button v-show="itemId" class="keepBtn" type="primary" size="medium">保存并完成设置</el-button>
    </div>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
    ></selectGoodsMonitor>
    <!-- :skuSearch="true" -->
    <!-- 确定礼包模板弹窗 -->
    <gift-popup :activityDataID="this.activityData.id" @handleChoice="handleChoice" v-if="giftPopup" />
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import giftPopup from "./giftPopup.vue";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import QRCode from "qrcodejs2";
import { mapState, mapMutations } from "vuex";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import { byPutKey } from "@/api/integralCenter/couponWriteController";
import { updateCommon } from "@/api/integralCenter/integralTask";
import draggable from "vuedraggable";
import {
  getPersonLabelList,
  createShopGift,
  getGiftBagTemplate,
  giftBagEide,
  editShopGift,
  getValidActivity,
  createThousandGift,
  editThousandGift,
  thousandGiftDetail,
  getGiftBagList,
} from "@/api/paradiseAndTaskCommonController.js";
import { jingdouAccount } from "@/api/integralCenter/prizeCenter.js";
const prizeName = ["", "", "京豆", "实物", "店铺积分", "京东E卡", "爱奇艺会员", "京东PLUS会员", "现金红包"];
export default {
  components: {
    selectGoodsMonitor,
    draggable,
    giftPopup,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activeValue: {
      type: Number,
    },
    valueRow: null,
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapState(["venderType"]),
    // 判断是否有草稿箱按钮
    hasDraftBtn(){
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    }
  },
  watch: {
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          // this.qrcodeAll(this.activityData.telCode, queryId);
          this.getCodeIMG();
        });
      }
    },
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      }
      return result;
    },
  },
  data() {
    return {
      isKeyActivity: 0,
      placementPosition: [],
      copyImg: "",
      openClick:3,
      isStart: false,
      jingdouAccountNum: 0, //京豆数量
      giftPopup: false,
      navList: [],
      tabActive: 0,
      defaultTime: this.$getDate(30, 25)[0].substring(11, this.$getDate(30, 25)[0].length),
      activityTimeValue: this.$getDate(30, 25),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.activityEndTime).valueOf()-24*60*60*1000;
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleForm.activityStartTime).valueOf();
        },
      },
      // venderType: true,
      giftPopup: false,
      activeName: "index0",
      crowIndex: 0,
      templateUrlimg: "",
      giftPrizeType: [], // 礼包样式数量
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      giftList: [], // 礼包模板
      // 获取人群
      personLab: {},
      personLabCrow: [],
      // 人群多选
      verCheckAll: false,
      starCheckAll: false,
      levelList: [],
      disableTime: false,
      clickActual: false,
      qrcode: null,
      order: "",
      showDialog: false,
      testInfo: [], //动态添加完善信息
      momentValue: {}, //编辑回显
      isShow: false,
      prizeSettingList: {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        discount: "",
        singleAmount: "",
      },
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.activityStartTime.indexOf("00:00:00") > -1) {
              return time.getTime(time) < new Date(this.ruleForm.activityStartTime).getTime();
            } else {
              return time.getTime(time) + day < new Date(this.ruleForm.activityStartTime).getTime();
            }
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return time.getTime() > new Date(this.ruleForm.activityEndTime).getTime();
          } else {
          }
        },
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      saveValue: [],
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
        },
      ],
      itemArrOne: [],
      localStep: this.stepNum,
      localStepNum: this.activityData.id,
      activityStartTime: null,
      activityEndTime: null,
      ruleForm: {
        //设置规则表单
        activityName: "",
        partner: ["-1"],
        isFollow: false,
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        prizeSite: "",
        information: [],
        activityStartTime: null, //活动开始时间
        activityEndTime: null, //活动结束时间
        singScore: null,
        activityRulesText: "", //生成规则
        bonusPoints: "", //活动名称，关注店铺有礼奖品设置积分
        peopleCount: "", //邀请开卡
        prizeSetOne: false,
        prizeCount: null,
        informationOne: [],
        isCumulativePrize: false,
        // 开卡  店铺
        isOutClose: "", //勾选奖品发完是否自动结束活动
        isExposureItem: "", //是否添加曝光商品 0 否 1 是
        requestFollow: "1", // 是否需要关注店铺
        sendCount: 0,
        isMemberGiftCheck: false,
        itemList: [], //曝光商品集合
      },
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [{ required: true, message: "请选择活动时间", trigger: "change" }],
        activityRulesText: [{ required: true, message: "请填写活动规则", trigger: "blur" }],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
      // 投放场景  tab切换
      scenariobCj: [
        { checkThrong: false }, // 未关注
        { checkThrong: false }, // 新客
        { checkThrong: false },
        { checkThrong: false },
        { checkThrong: false },
      ],
      // 投放场景   tab切换下面的全选check
      scenariobCheckAll: [
        { checkThrong: false }, // 全选
        { checkThrong: false },
        { checkThrong: false },
        { checkThrong: false },
        { checkThrong: false },
      ],
      // 投放场景 人群多选
      scenariobRidCheck: [
        { checkThrong: [] }, // tab切换下面的多选check
        { checkThrong: [] },
        { checkThrong: [] },
        { checkThrong: [] },
        { checkThrong: [] },
      ],
      // 礼包list
      sceneList: [
        {
          giftPrizeType: -1, //模板类型
          templateNum: 0, // 模板数量
          sceneType: "", //千人千面场景礼包类型 1:未关注店铺用户 2:店铺新客 3:plus会员 4:关注店铺用户 5:店铺会员
          peopleModels: "", //千人千面人群标识 示例：v1_customer:-1_1
          giftTemplateId: "", //礼包模板id
          templateUrlimg: "", // 礼包模板图
          customPicUrl: "", //自定义图片
          sendCount: "", //发送人数
          jfcheck: "", //积分选择
          jdcheck: "", //京豆选择
          dqcheck: "", //东券选择
          jqcheck: "", //京券选择
          jfprice: "", //积分总共奖品数量
          jdprice: "", //京豆共奖品数量
          dqkey: "", //东券key
          dqprice: "", //面额
          dqday: "", //有效期
          dqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          jqkey: "", //京券key
          jqprice: "", //=面额
          jqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          jqday: "", //有效期
          buttonText: "", //确定按钮
          jumpLink: "", //跳转链接
          jqkeyInspect: false,
          dqkeyInspect: false,
          jfshow: false, // 积分的显示隐藏
          jdshow: false, // 京豆的显示隐藏
          dqshow: false, // 东券的显示隐藏
          jqshow: false, // 京券的显示隐藏
        },
        {
          giftPrizeType: -1, //模板类型
          templateNum: 0, // 模板数量
          sceneType: "",
          peopleModels: "",
          giftTemplateId: "",
          templateUrlimg: "", // 礼包模板图
          customPicUrl: "", //自定义图片
          sendCount: "",
          jfcheck: "", //积分选择
          jdcheck: "", //京豆选择
          dqcheck: "", //东券选择
          jqcheck: "", //京券选择
          jfprice: "", //积分总共奖品数量
          jdprice: "", //京豆共奖品数量
          dqkey: "", //东券key
          dqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          dqprice: "", //面额
          dqday: "", //有效期
          jqkey: "", //京券key
          jqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          jqprice: "", //面额
          jqday: "", //有效期
          buttonText: "", //确定按钮
          jumpLink: "", //跳转链接
          jqkeyInspect: false,
          dqkeyInspect: false,
          jfshow: false,
          jdshow: false,
          dqshow: false,
          jqshow: false,
        },
        {
          giftPrizeType: -1, //模板类型
          templateNum: 0, // 模板数量
          sceneType: "",
          peopleModels: "",
          giftTemplateId: "",
          templateUrlimg: "", // 礼包模板图
          customPicUrl: "", //自定义图片
          sendCount: "",
          jfcheck: "", //积分选择
          jdcheck: "", //京豆选择
          dqcheck: "", //东券选择
          jqcheck: "", //京券选择
          jfprice: "", //积分总共奖品数量
          jdprice: "", //京豆共奖品数量
          dqkey: "", //东券key
          dqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          dqprice: "", //面额
          dqday: "", //有效期
          jqkey: "", //京券key
          jqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          jqprice: "", //面额
          jqday: "", //有效期
          buttonText: "", //确定按钮
          jumpLink: "", //跳转链接
          jqkeyInspect: false,
          dqkeyInspect: false,
          jfshow: false,
          jdshow: false,
          dqshow: false,
          jqshow: false,
        },
        {
          giftPrizeType: -1, //模板类型
          templateNum: 0, // 模板数量
          sceneType: "",
          peopleModels: "",
          giftTemplateId: "",
          templateUrlimg: "", // 礼包模板图
          customPicUrl: "", //自定义图片
          sendCount: "",
          jfcheck: "", //积分选择
          jdcheck: "", //京豆选择
          dqcheck: "", //东券选择
          jqcheck: "", //京券选择
          jfprice: "", //积分总共奖品数量
          jdprice: "", //京豆共奖品数量
          dqkey: "", //东券key
          dqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          dqprice: "", //面额
          dqday: "", //有效期
          jqkey: "", //京券key
          jqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          jqprice: "", //面额
          jqday: "", //有效期
          buttonText: "", //确定按钮
          jumpLink: "", //跳转链接
          jqkeyInspect: false,
          dqkeyInspect: false,
          jfshow: false,
          jdshow: false,
          dqshow: false,
          jqshow: false,
        },
        {
          giftPrizeType: -1, //模板类型
          templateNum: 0, // 模板数量
          sceneType: "",
          peopleModels: "",
          giftTemplateId: "",
          templateUrlimg: "", // 礼包模板图
          customPicUrl: "", //自定义图片
          sendCount: "",
          jfcheck: "", //积分选择
          jdcheck: "", //京豆选择
          dqcheck: "", //东券选择
          jqcheck: "", //京券选择
          jfprice: "", //积分总共奖品数量
          jdprice: "", //京豆共奖品数量
          dqkey: "", //东券key
          dqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          dqprice: "", //面额
          dqday: "", //有效期
          jqkey: "", //京券key
          jqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          jqprice: "", //面额
          jqday: "", //有效期
          buttonText: "", //确定按钮
          jumpLink: "", //跳转链接
          jqkeyInspect: false,
          dqkeyInspect: false,
          jfshow: false,
          jdshow: false,
          dqshow: false,
          jqshow: false,
        },
      ],
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      isDraft:false
    };
  },
  async created() {
    this.Fun_jingdouAccount();
    if (this.activityData.id == 15) {
      // 店铺礼包千人千面数据初始化
      //  导航分类
      const GiftBag = await getGiftBagList(2);
      this.navList = [
        {
          id: "",
          isVisible: true,
          title: "全部",
        },
        ...GiftBag.data,
      ];
      this.navItem = this.navList[0];
      await this.getPolite();
      // 获取人群
      const { data: res } = await getPersonLabelList();
      this.personLab = res.filter((i) => i.labelName != "全部用户");
      // 循环人群数据
      this.personLabCrow = [this.personLab[0]];
      this.ruleForm.modelIds = res[0].labelId;
    }
    if (this.activeValue) {
      this.activityData.id = this.activeValue;
      await this.getEdit();
    }
    // 新增活动默认时间
    if(!this.valueRow){
      this.ruleForm.activityStartTime = this.$getDate(30, 25)[0]
      this.ruleForm.activityEndTime = this.$getDate(30, 25)[1]
      this.activityTimeChange();
    }
  },
  mounted() {
    this.isStart = this.activityData.isStart ? true : false
    this.getLevel();
    // this.$nextTick(() => {
    //   if (this.activityData.id != 15) {
    //     this.getCodeIMG();
    //     this.qrcodeAll(this.activityData.telCode, queryId);
    //   }
    // });
    //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
    // console.log(this.activeValue, 99996);
  },
  methods: {
    Fun_jingdouAccount() {
      jingdouAccount().then((res) => {
        console.log("res", res);
        this.jingdouAccountNum = res.data.availableNum || 0;
      });
    },

    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.getPolite();
    },
    // 分页查询事件
    handleSizeChange(val) {
      this.pageData.size = val;
      this.getPolite();
    },
    handleCurrentChange(val) {
      this.pageData.current = val;
      this.getPolite();
    },
    // 店铺礼包千人千面数据初始化
    async getPolite() {
      this.loading = true;
      // 开卡礼包版本
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        dirId: this.navItem.id,
        giftType: 2,
      };
      const { data } = await getGiftBagTemplate(params);
      this.giftList = data.records.map((item) => ({
        ...item,
        days: item.expirationType == 1 ? this.getDaysBetween(item.expirationStartDate, item.expirationEndDate) : "",
      }));
      this.pageData.total = data.total * 1;
      console.log(data, 2222);
      // this.giftList = giftList.filter((i) => i.giftType == 2);

      this.$nextTick(() => {
        this.getCodeIMG();
      });
      this.loading = false;
    },
    // 修改 数据回显
    async getEdit() {
      if (this.activeValue == 15) {
        // 店铺礼包
        const { data: res } = await thousandGiftDetail(this.valueRow.id);
        this.fromLoading = true;
        // this.activityTimeValue = [String(res.startTime), String(res.endTime)];
        this.ruleForm.activityName = res.activityName;
        this.ruleForm.activityStartTime = res.startTime?String(res.startTime):null;
        this.ruleForm.activityEndTime = res.endTime?String(res.endTime):null;
        this.ruleForm.requestFollow = res.ruleDTO.requestFollow ? "1" : "2"; //是否需要关注店铺
        // 投放场景 [1,2,3,4,5]
        const sceneTypePut = res.ruleDTO.sceneTypePut ? res.ruleDTO.sceneTypePut.split(",") : [];
        // console.log(sceneTypePut, 666666);
        this.crowIndex = sceneTypePut.length ? sceneTypePut[0] - 1 : 0; //默认投放场景第一个inedx值
        sceneTypePut.forEach((item, i) => {
          this.scenariobCj[item - 1].checkThrong = true;
          // 投放场景下的数据处理
          this.sceneList[item - 1].sendCount = res.sceneList[i].sendCount; // 人数
          this.sceneList[item - 1].giftTemplateId = res.sceneList[i].giftTemplateId; // 礼包id
          this.sceneList[item - 1].templateUrlimg = res.sceneList[i].giftTemplateUrl; // 礼包url
          this.sceneList[item - 1].customPicUrl = res.sceneList[i].customPicUrl; // 自定义url
          this.sceneList[item - 1].buttonText = res.sceneList[i].buttonText; // 文案按钮确认
          this.sceneList[item - 1].jumpLink = res.sceneList[i].jumpLink; // 跳转链接
          const peopleModels = res.sceneList[i].peopleModels.split(":");
          this.scenariobRidCheck[item - 1].checkThrong = peopleModels[1].split("_"); //投放场景对应人群
          //对应人群的全选
          if (this.personLab[item - 1].labelVal.length == this.scenariobRidCheck[item - 1].checkThrong.length) {
            this.scenariobCheckAll[item - 1].checkThrong = true;
          }
          // 礼包显示隐藏
          if(!this.activityData.isCopy){
            const giftTemplatePrizeType = res.sceneList[i].giftTemplatePrizeType ? res.sceneList[i].giftTemplatePrizeType.split(",") : [];
            this.sceneList[item - 1].templateNum = giftTemplatePrizeType.length; //模板数量
            this.sceneList[item - 1].giftPrizeType = res.sceneList[i].giftPrizeType; //模板类型
            // 1 店铺积分  2 京豆  3  京券  4  东券
            giftTemplatePrizeType.forEach((query) => {
              if (query == 1) {
                this.sceneList[item - 1].jfshow = true;
              }
              if (query == 2) {
                this.sceneList[item - 1].jdshow = true;
              }
              if (query == 3) {
                this.sceneList[item - 1].jqshow = true;
              }
              if (query == 4) {
                this.sceneList[item - 1].dqshow = true;
              }
            });
            res.sceneList[i].prizes = res.sceneList[i].prizes ? res.sceneList[i].prizes : [];
            res.sceneList[i].prizes.forEach((ele) => {
              // 积分
              if (ele.prizeType === 6) {
                // 积分勾选框
                this.sceneList[item - 1].jfcheck = true;
                this.sceneList[item - 1].jfprice = ele.price;
              }
              // 京豆 4
              if (ele.prizeType === 4) {
                // 京豆勾选框
                this.sceneList[item - 1].jdcheck = true;
                this.sceneList[item - 1].jdprice = ele.price;
              }
              // 京券 0
              if (ele.prizeType === 0) {
                // 京券勾选框
                this.sceneList[item - 1].jqcheck = true;
                this.sceneList[item - 1].jqprice = ele.price;
                this.sceneList[item - 1].jqquota = ele.quota;
                this.sceneList[item - 1].jqday = ele.validateDay;
                if (ele.batchKey && this.venderType) {
                  this.sceneList[item - 1].jqkeyInspect = true;
                }
              }
              // 东券 1
              if (ele.prizeType === 1) {
                // 京券勾选框
                this.sceneList[item - 1].dqcheck = true;
                this.sceneList[item - 1].dqprice = ele.price;
                this.sceneList[item - 1].dqquota = ele.quota;
                this.sceneList[item - 1].dqday = ele.validateDay;
                if (ele.batchKey && this.venderType) {
                  this.sceneList[item - 1].jqkeyInspect = true;
                }
              }
            });
          }
        });
        //曝光商品集合
        this.ruleForm.exposureSwitch = res.isExposureItem == 0 ? false : true;
        this.selectGoodsArr = res.itemList;
        // this.itemListFor = res.itemList;
        this.mainImagelist = res.itemList;
        this.ruleForm.radio = res.isExposureItem; // 是否加购商品
        // this.templateUrlimg = res.giftTemplateUrl;
        this.itemListFor = res.itemList;
        this.activityTimeChange();
        // 未选择的投放场景礼包模板默认
        const sceneListShow = this.sceneList[this.crowIndex];
        this.scenariobCj.forEach((item, i) => {
          if (!item.checkThrong) {
            this.sceneList[i].giftTemplateId = sceneListShow.giftTemplateId; // 礼包id
            this.sceneList[i].templateUrlimg = sceneListShow.templateUrlimg; // 礼包url
            this.sceneList[i].customPicUrl = sceneListShow.customPicUrl; // 自定义url
            this.sceneList[i].templateNum = sceneListShow.templateNum; //模板数量
            this.sceneList[i].giftPrizeType = sceneListShow.giftPrizeType; //模板类型
            if (sceneListShow.jfshow) {
              this.sceneList[i].jfshow = true;
            }
            if (sceneListShow.jdshow) {
              this.sceneList[i].jdshow = true;
            }
            if (sceneListShow.jqshow) {
              this.sceneList[i].jqshow = true;
            }
            if (sceneListShow.dqshow) {
              this.sceneList[i].dqshow = true;
            }
          }
        });
        // 是否重点活动
        this.isKeyActivity = res.isKeyActivity || 0;
        this.placementPosition = res.placementPosition ? res.placementPosition.split(",") : ["SHOP"];
        this.fromLoading = false;
      }
    },
    // 投放场景
    handleCrow(item, index) {
      if(this.isStart) return;
      this.personLabCrow = [item];
    },
    addPrizeRule() {
      this.tableData.push({
        peopleCount: "",
        prizeType: "",
        value: "",
        prizeCount: "",
      });
    },
    colseDialog() {
      this.showDialog = false;
      this.clickActual = false;
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          console.log(res, 6667);
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          console.log(this.levelList, 111112);
        })
        .catch((res) => {});
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      // const url = "http://yq-hd-rc.isvjcloud.com/shop.html";
      const url = "http://yq-hd-rc.isvjcloud.com/shop.html";
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: `${url}?image=${this.giftList[index].templateExampleUrl}`,
        });
      }
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 140, // 设置宽度，单位像素
        height: 140, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1 || e.target.value >= 1000000000) {
        e.target.value = "";
      }
    },
    //清空商品数据
    deleteCoupon() {
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
    },
    //模板下一步
    nextStep() {
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
    },
    //千人千面
    nextStepKai(items) {
      //新增判断
      getValidActivity().then((res) => {
        if (res.data) {
          const message =
            "当前正在进行【" +
            res.data[0].activityName +
            "】活动" +
            res.data[0].activityStartTime +
            "~" +
            res.data[0].activityEndTime +
            "，必须结束后才能新建！";
          this.$message.warning(message);
          return;
        }

        // this.giftPrizeType = items.prizeType ? items.prizeType.split(",") : [];
        // 1 店铺积分  2 京豆  3  京券  4  东券
        const prizeType = items.prizeType ? items.prizeType.split(",") : [];
        // this.awardNumLimit = items.awardNumLimit //Tag: wk
        this.copyImg = items.templateUrl
        this.sceneList.forEach((i) => {
          i.templateNum = prizeType.length;
          i.giftPrizeType = items.giftPrizeType;
          i.templateUrlimg = items.templateUrl;
          i.customPicUrl = items.templateUrl;
          i.giftTemplateId = items.id;
          i.awardNumLimit = items.awardNumLimit;
          prizeType.forEach((ele) => {
            if (ele == 1) {
              i.jfshow = true;
            }
            if (ele == 2) {
              i.jdshow = true;
            }
            if (ele == 3) {
              i.jqshow = true;
            }
            if (ele == 4) {
              i.dqshow = true;
            }
          });
        });

        this.localStep = 1;
        this.$emit("titopName", this.activityData.name, true);
      });
      this.Fun_jingdouAccount();
    },
    //千人千面
    nextStepKai1(items) {
      // this.giftPrizeType = items.prizeType ? items.prizeType.split(",") : [];
      // 1 店铺积分  2 京豆  3  京券  4  东券
      const prizeType = items.prizeType ? items.prizeType.split(",") : [];
      // this.awardNumLimit = items.awardNumLimit //Tag: wk
      this.copyImg = items.templateUrl
      this.sceneList.forEach((i) => {
        i.templateNum = prizeType.length;
        i.giftPrizeType = items.giftPrizeType;
        i.templateUrlimg = items.templateUrl;
        i.customPicUrl = items.templateUrl;
        i.giftTemplateId = items.id;
        i.awardNumLimit = items.awardNumLimit;
        prizeType.forEach((ele) => {
          if (ele == 1) {
            i.jfshow = true;
          }
          if (ele == 2) {
            i.jdshow = true;
          }
          if (ele == 3) {
            i.jqshow = true;
          }
          if (ele == 4) {
            i.dqshow = true;
          }
        });
      });

      this.localStep = 1;
      this.$emit("titopName", this.activityData.name, true);

      this.Fun_jingdouAccount();
    },

    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
    },
    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
      // console.log(this.selectGoodsArr, 4444444);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //商品回调
    selectGoodsChange(val) {
      this.goodsState = false;
    },
    //活动时间驱动
    activityTimeChange(val) {
      // this.ruleForm.activityStartTime = this.activityTimeValue[0];
      // this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let invalidateDate = new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      // daysStart = this.ruleForm.activityStartTime.substring(0, 10);
      // daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime != "" && this.ruleForm.activityStartTime != "") {
        // datas = daysEnd.split("-");
        // change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // datas = daysStart.split("-");
        // change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(Math.abs(new Date(this.ruleForm.activityEndTime)-new Date(this.ruleForm.activityStartTime)) / 1000 / 60 / 60 / 24);

        if (this.timeDay < 1 && !this.backgroundOpacity) {
          this.$message.warning("活动间隔最少为1天！");
          // this.activityTimeValue[1] = "";
          this.ruleForm.activityEndTime = "";
          this.timeOut = 0;
          this.timeDay = 0;
          return;
        }
        console.log(days);
        if (days > 90) {
          this.$message.warning("活动时间不得超过90天!");
          // this.activityTimeValue[1] = "";
          this.ruleForm.activityEndTime = "";
          return;
        }

        // this.timeDay = days;
        //计算小时
        date3 = new Date(this.ruleForm.activityEndTime).getTime() - new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }
      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.ruleForm.activityEndTime = null;
        return;
      }
      // if (start < nowTime) {
      if ((start - nowTime) / 1000 / 60 < 20) {
        if (this.activeValue) {
          this.disableTime = true;
        } else {
          // this.$message.warning("活动时间开始时间要大于当前时间的20分钟");
          // this.activityTimeValue[0] = "";
          this.ruleForm.activityStartTime = "";
          // return;
        }
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.ruleForm.activityEndTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        // this.activityTimeValue[1] = "";
        // this.ruleForm.activityEndTime = null;
        return;
      }
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      // this.$emit("returnBack");
      if (this.localStep == 0) this.$emit("returnBack");
      if (this.localStep == 1) this.localStep = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      //活动名称的限制
      if (!this.ruleForm.activityName || this.ruleForm.activityName.length == 0) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      let nowTime = new Date().getTime();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        return
      }
      if (this.ruleForm.radio == "1") {
        if (this.itemListFor.length == 0) {
          return this.$message.warning("请选择加购商品！");
        }
      }
      //投放场景sceneList合集处理
      const typePut = this.scenariobCj.map((item, i) => {
        if (item.checkThrong) {
          return i + 1;
        }
      });
      // 把空字段过滤
      let information = typePut.filter((item) => item);
      if (information.length == 0) {
        return this.$message.warning("至少勾选一个投放场景");
      }
      let isWarning = false
      let waringMsg =''
      let reversedArray = information.slice().reverse(); 
      reversedArray.forEach(item=>{
        // 人群
        if (this.scenariobRidCheck[item - 1].checkThrong.length == 0) {
          isWarning = true
          if(item == 1){
            waringMsg = '未关注店铺用户【增加店铺关注用户】场景未填写完整，请填写完整后保存'
          }else if(item == 2){
            waringMsg = '店铺新客【新客转化】场景未填写完整，请填写完整后保存'
          }else if(item == 3){
            waringMsg = 'plus会员场景未填写完整，请填写完整后保存'
          }else if(item == 4){
            waringMsg = '关注店铺用户场景未填写完整，请填写完整后保存'
          }else if(item == 5){
            waringMsg = '店铺会员场景未填写完整，请填写完整后保存'
          }
        }
        else if(!this.sceneList[item - 1].sendCount ){
          isWarning = true
          waringMsg = "请填写发送人数！";
        }
        else if (!this.sceneList[item - 1].jfcheck && !this.sceneList[item - 1].jdcheck && !this.sceneList[item - 1].dqcheck) {
          isWarning = true
           waringMsg = "请选择礼包样式！";
        }
       else {
          console.log("this.sceneList[item - 1]",this.sceneList[item - 1])
            if (this.sceneList[item - 1].jfcheck) {
            if (!this.sceneList[item - 1].jfprice) {
              isWarning = true
              waringMsg = "请输入每份店铺积分！"
            }

          }
          if (this.sceneList[item - 1].jdcheck) {
            if (!this.sceneList[item - 1].jdprice) {
              isWarning = true;
              waringMsg = "请输入每份京豆额！"
            }
          }
          if (this.sceneList[item - 1].dqcheck) {
            if(!this.venderType){
              if (!this.sceneList[item - 1].dqprice || !this.sceneList[item - 1].dqquota || !this.sceneList[item - 1].dqday) {
                isWarning = true
                waringMsg = "请填写东券信息！"
              }
            }else{
              if (!this.sceneList[item - 1].dqkey) {
                isWarning = true
                waringMsg = "请填写东券信息！"
              }
            }
          }
        }
      })
      if(isWarning){
        return this.$message.warning(waringMsg)
      }
      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置！");
        return
      }
      
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft(){
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if(this.isDraftEdit){
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }else{
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      let cardParams = {
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        activityType: this.activityData.id, //活动类型  15店铺礼包千人千面
        isExposureItem: this.ruleForm.radio, //是否添加曝光商品 0 否 1 是
        ruleDTO: {
          requestFollow: this.ruleForm.requestFollow == "1" ? true : false, //是否需要关注店铺sceneTypePut
          sceneTypePut: "", //
        },
        sceneList: [],
        itemList: this.itemListFor, //曝光商品集合
        isKeyActivity: this.isKeyActivity, // 是否重点活动
        placementPosition: this.placementPosition.join(","),
      };
      if(!this.isDraft){
        //活动名称的限制
        if (!this.ruleForm.activityName || this.ruleForm.activityName.length == 0) {
          this.$message.warning("请输入活动名称");
          return;
        }
        //活动时间的限制
        if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
          this.$message.warning("请输入活动时间");
          return;
        }
        let nowTime = new Date().getTime();
        let end = new Date(this.ruleForm.activityEndTime).valueOf();
        if (end < nowTime) {
          this.$message.warning("结束时间不能小于当前时间");
          return
        }
        if (this.ruleForm.radio == "1") {
          if (this.itemListFor.length == 0) {
            return this.$message.warning("请选择加购商品！");
          }
        }
        //投放场景sceneList合集处理
        const typePut = this.scenariobCj.map((item, i) => {
          if (item.checkThrong) {
            return i + 1;
          }
        });
        // 把空字段过滤
        const information = typePut.filter((item) => item);
        if (information.length == 0) {
          return this.$message.warning("至少勾选一个投放场景");
        }
        cardParams.ruleDTO.sceneTypePut = information.join(); // 投放场景类型
        let libao = []; // 礼包样式没有选择
        let jfOption = false; // 礼包奖项 积分未填写完整
        let jdOption = false; // 礼包奖项 京豆未填写完整
        let dqOption = false; // 礼包奖项 东券未填写完整
        let jqOption = false; // 礼包奖项 京卷未填写完整
        let description = false; // 人群
        let buttonText = false; // 按钮文案
        let sendCount = false; // 发送人数
        information.forEach((item) => {
          let obj = {
            sceneType: item, //千人千面场景礼包类型 1:未关注店铺用户 2:店铺新客 3:plus会员 4:关注店铺用户 5:店铺会员
            peopleModels: this.personLab[item - 1].labelId + ":" + this.scenariobRidCheck[item - 1].checkThrong.join("_"), //人群标识 示例：v1_customer:-1_1
            sendCount: this.sceneList[item - 1].sendCount,
            giftTemplateId: this.sceneList[item - 1].giftTemplateId,
            giftTemplateUrl: this.sceneList[item - 1].templateUrlimg,
            customPicUrl: this.sceneList[item - 1].customPicUrl,
            prizes: [],
            buttonText: this.sceneList[item - 1].buttonText,
            jumpLink: this.sceneList[item - 1].jumpLink,
          };
          // 积分
          if (this.sceneList[item - 1].jfcheck) {
            const data = {
              price: this.sceneList[item - 1].jfprice,
              prizeType: 6, // 奖项类型  0:京券 1:东券 4:京豆 6:积分
              singleAmount: this.sceneList[item - 1].jfprice,
              title: this.sceneList[item - 1].jfprice + "积分",
              totalAmount: this.sceneList[item - 1].sendCount,
            };
            obj.prizes.push(data);
            if (!this.sceneList[item - 1].jfprice) {
              jfOption = true;
            }
          }
          // 京豆
          if (this.sceneList[item - 1].jdcheck) {
            const data = {
              price: this.sceneList[item - 1].jdprice,
              prizeType: 4, // 奖项类型  0:京券 1:东券 4:京豆 6:积分
              singleAmount: this.sceneList[item - 1].jdprice,
              title: this.sceneList[item - 1].jdprice + "京豆",
              totalAmount: this.sceneList[item - 1].sendCount,
            };
            obj.prizes.push(data);
            if (!this.sceneList[item - 1].jdprice) {
              jdOption = true;
            }
          }
          // 京券
          if (this.sceneList[item - 1].jqcheck) {
            const data = {
              price: this.sceneList[item - 1].jqprice,
              prizeType: 0, // 奖项类型  0:京券 1:东券 4:京豆 6:积分
              singleAmount: 1, // 京、东券默认为1
              title: "满" + this.sceneList[item - 1].jqquota + "减" + this.sceneList[item - 1].jqprice + "元券",
              totalAmount: this.sceneList[item - 1].sendCount,
              validateDay: this.sceneList[item - 1].jqday, //优惠券有效天数
              quota: this.sceneList[item - 1].jqquota, //满足优惠的消费金额 ；例满100减1的东券，此处填写100
            };
            if (this.venderType) {
              data.batchKey = this.sceneList[item - 1].jqkey;
              if (!this.sceneList[item - 1].jqkey) {
                jqOption = true;
              }
            }
            obj.prizes.push(data);
            if (!this.sceneList[item - 1].jqprice || !this.sceneList[item - 1].jqquota || !this.sceneList[item - 1].jqday) {
              jqOption = true;
            }
          }
          // 东券
          if (this.sceneList[item - 1].dqcheck) {
            const data = {
              price: this.sceneList[item - 1].dqprice,
              prizeType: 1, // 奖项类型  0:京券 1:东券 4:京豆 6:积分
              singleAmount: 1, // 京、东券默认为1
              title: "满" + this.sceneList[item - 1].dqquota + "减" + this.sceneList[item - 1].dqprice + "元券",
              totalAmount: this.sceneList[item - 1].sendCount,
              validateDay: this.sceneList[item - 1].dqday, //优惠券有效天数
              quota: this.sceneList[item - 1].dqquota, //满足优惠的消费金额 ；例满100减1的东券，此处填写100
            };
            if (this.venderType) {
              data.batchKey = this.sceneList[item - 1].dqkey;
              if (!this.sceneList[item - 1].dqkey) {
                dqOption = true;
              }
            }
            obj.prizes.push(data);
            if (!this.venderType) {
              if (!this.sceneList[item - 1].dqprice || !this.sceneList[item - 1].dqquota || !this.sceneList[item - 1].dqday) {
                dqOption = true;
              }
            }
          }
          // 人群
          if (this.scenariobRidCheck[item - 1].checkThrong.length == 0) {
            description = true;
          }
          //
          if (this.scenariobRidCheck[item - 1].sendCount) {
            sendCount = true;
          }
          // 礼包确认按钮文案
          if (!this.sceneList[item - 1].buttonText) {
            buttonText = true;
          }
          // 礼包样式没有选择
          if (
            !this.sceneList[item - 1].jfcheck &&
            !this.sceneList[item - 1].jdcheck &&
            !this.sceneList[item - 1].dqcheck && 
            !this.sceneList[item - 1].jqcheck
          ) {
            libao[item - 1] = true;
          }
          cardParams.sceneList.push(obj);
        });
        let flag = false;
        libao.forEach(item => {
          if(item == true) flag = true;
        })
        if (flag) {
          return this.$message.warning("至少选择一项礼包！");
        }
        if (description) {
          return this.$message.warning("请选择对应的人群！");
        }
        if (sendCount) {
          return this.$message.warning("请填写发送人数！");
        }
        if (jfOption) {
          return this.$message.warning("请输入每份店铺积分！");
        }
        if (jdOption) {
          return this.$message.warning("请输入每份京豆额！");
        }
        if (dqOption) {
          return this.$message.warning("请填写东券信息！");
        }
        if (jqOption) {
          return this.$message.warning("请填写京券信息！");
        }
      } else {
         //投放场景sceneList合集处理
         const typePut = this.scenariobCj.map((item, i) => {
          if (item.checkThrong) {
            return i + 1;
          }
        });
        if(typePut.length) {
          // 把空字段过滤
          const information = typePut.filter((item) => item);
          cardParams.ruleDTO.sceneTypePut = information.join(); // 投放场景类型
          information.forEach((item) => {
            let obj = {
              sceneType: item, //千人千面场景礼包类型 1:未关注店铺用户 2:店铺新客 3:plus会员 4:关注店铺用户 5:店铺会员
              peopleModels: this.personLab[item - 1].labelId + ":" + this.scenariobRidCheck[item - 1].checkThrong.join("_"), //人群标识 示例：v1_customer:-1_1
              sendCount: this.sceneList[item - 1].sendCount,
              giftTemplateId: this.sceneList[item - 1].giftTemplateId,
              giftTemplateUrl: this.sceneList[item - 1].templateUrlimg,
              customPicUrl: this.sceneList[item - 1].customPicUrl,
              prizes: [],
              buttonText: this.sceneList[item - 1].buttonText,
              jumpLink: this.sceneList[item - 1].jumpLink,
            };
            cardParams.sceneList.push(obj);
          });
        }
      }
      // if (buttonText) {
      //   return this.$message.warning("请输入礼包按钮文案！");
      // }
      // console.log(cardParams, this.checked, 66666);
      //判断勾选提示后即可调取接口
      if (this.checked == true || this.isDraft) {
        if (this.activityData.id == 15) {
          if (this.valueRow && !this.activityData.isCopy && !this.isDraft && !this.isDraftEdit) {
            //修改礼包 店铺 千人千面
            let res;
            if(this.activityData.isStart){
              let params = {
                activityId: this.valueRow.id,
                // endTime: cardParams.endTime,
                ruleDescription: cardParams.ruleDescription,
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListFor,
              }
              res = await updateCommon(params)
            }else{
              res = await editThousandGift({...cardParams, id: this.valueRow.id})
            }
            // editThousandGift({ ...cardParams, id: this.valueRow.id }).then((res) => {
              if (res.code == 1) {
                this.$emit("saveEdit");
                this.$message.success(res.message);
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error(res.data.message);
                }
              }
            // });
          } else {
            if(this.isDraft){
              cardParams.status = 5
            }
            // 草稿箱编辑-添加活动id
            if(this.isDraftEdit){
              cardParams.id = this.valueRow.id
            }
            if(this.activityData.isCopy){
              delete cardParams.id
            }
            //创建礼包 店铺 千人千面
            createThousandGift(cardParams).then((res) => {
              if (res.code == 1) {
                if(this.isDraft){
                  this.$message.success("保存成功！")
                  this.$emit("returnBack",true);
                }else{
                  this.$emit("saveEdit");
                  this.$message.success(res.message);
                }
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error(res.data.message);
                }
              }
            });
          }
        }
        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsState = false;
        return;
      }
    },
    selectGoodsClose(data) {
      console.log(data);
      if (data) {
        console.log(data);
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        this.selectGoodsArr = this.itemListFor;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },
    // 多选
    handleCheckedStarChange(val) {
      console.log(val);
      const data = this.personLab.recommendList[this.personLab.recommendList.length - 1].labelVal.map((i) => i.level);
      this.ruleForm.starVal = val ? data : [];
      this.starCheckAll = val;
    },
    // 投放场景  下的  全选
    handleCheckedChange(val) {
      console.log(val);
      console.log(this.scenariobCheckAll, this.crowIndex);
      if (val) {
        // 当全选确定  改下面的多选
        this.scenariobRidCheck[this.crowIndex].checkThrong = this.personLabCrow[0].labelVal.map((i) => i.level);
        console.log(this.scenariobRidCheck);
      } else {
        this.scenariobRidCheck[this.crowIndex].checkThrong = [];
      }
    },
    handleChang() {
      const num = this.personLabCrow[0].labelVal.map((i) => i.level);
      const num1 = this.scenariobRidCheck[this.crowIndex].checkThrong;
      if (num.length === num1.length) {
        this.scenariobCheckAll[this.crowIndex].checkThrong = true;
      } else {
        this.scenariobCheckAll[this.crowIndex].checkThrong = false;
      }


      if(this.scenariobRidCheck[this.crowIndex].checkThrong.indexOf('-1') == -1 && this.scenariobRidCheck[this.crowIndex].checkThrong.length != 0){
          this.openClick = 1;
      }else if(this.scenariobRidCheck[this.crowIndex].checkThrong.length == 0){
        this.openClick = 3 ;
      }else{
        this.openClick = 2 ;
      }
    },
    // 品牌定制弹窗
    handleOpen() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    //输入框限制负数
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        this.$message.warning("发放人数需要大于0");
        e.target.value = "";
      }
    },
    // 限免日期
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
    //曝光商品
    exposureChange(val) {
      if (val == "0") {
        this.ruleForm.exposureSwitch = false;
        this.itemListFor = [];
        this.mainImagelist = [];
      } else {
        this.ruleForm.exposureSwitch = true;
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if(!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if(this.activityData.isCopy) return this.localStep = 0;
      this.localStep = 0;
      this.localStepNum = 0;
      this.ruleForm.radio = 0;
      this.ruleForm.exposureSwitch = false;
      this.itemListFor = [];
      this.ruleForm.isOutClose = "";
      this.ruleForm.activityName = ""; //活动类型  13: 开卡礼包 14: 店铺礼包
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
      this.giftPopup = false;
      this.activeName = "index0";
      this.crowIndex = 0;
      // 投放场景  tab切换
      this.scenariobCj = [
        { checkThrong: false }, // 未关注
        { checkThrong: false }, // 新客
        { checkThrong: false },
        { checkThrong: false },
        { checkThrong: false },
      ];
      // 投放场景   tab切换下面的全选check
      this.scenariobCheckAll = [
        { checkThrong: false }, // 全选
        { checkThrong: false },
        { checkThrong: false },
        { checkThrong: false },
        { checkThrong: false },
      ];
      // 投放场景 人群多选
      this.scenariobRidCheck = [
        { checkThrong: [] }, // tab切换下面的多选check
        { checkThrong: [] },
        { checkThrong: [] },
        { checkThrong: [] },
        { checkThrong: [] },
      ];
      // 礼包list
      this.sceneList = [
        {
          sceneType: "", //千人千面场景礼包类型 1:未关注店铺用户 2:店铺新客 3:plus会员 4:关注店铺用户 5:店铺会员
          peopleModels: "", //千人千面人群标识 示例：v1_customer:-1_1
          giftTemplateId: "", //礼包模板id
          templateUrlimg: "", // 礼包模板图
          sendCount: "", //发送人数
          jfcheck: "", //积分选择
          jdcheck: "", //京豆选择
          dqcheck: "", //东券选择
          jqcheck: "", //京券选择
          jfprice: "", //积分总共奖品数量
          jdprice: "", //京豆共奖品数量
          dqkey: "", //东券key
          dqprice: "", //面额
          dqday: "", //有效期
          dqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          jqkey: "", //京券key
          jqprice: "", //=面额
          jqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          jqday: "", //有效期
          buttonText: "", //确定按钮
          jumpLink: "", //跳转链接
          jqkeyInspect: false,
          dqkeyInspect: false,
          jfshow: false, // 积分的显示隐藏
          jdshow: false, // 京豆的显示隐藏
          dqshow: false, // 东券的显示隐藏
          jqshow: false, // 京券的显示隐藏
        },
        {
          sceneType: "",
          peopleModels: "",
          giftTemplateId: "",
          templateUrlimg: "", // 礼包模板图
          sendCount: "",
          jfcheck: "", //积分选择
          jdcheck: "", //京豆选择
          dqcheck: "", //东券选择
          jqcheck: "", //京券选择
          jfprice: "", //积分总共奖品数量
          jdprice: "", //京豆共奖品数量
          dqkey: "", //东券key
          dqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          dqprice: "", //面额
          dqday: "", //有效期
          jqkey: "", //京券key
          jqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          jqprice: "", //面额
          jqday: "", //有效期
          buttonText: "", //确定按钮
          jumpLink: "", //跳转链接
          jqkeyInspect: false,
          dqkeyInspect: false,
          jfshow: false,
          jdshow: false,
          dqshow: false,
          jqshow: false,
        },
        {
          sceneType: "",
          peopleModels: "",
          giftTemplateId: "",
          templateUrlimg: "", // 礼包模板图
          sendCount: "",
          jfcheck: "", //积分选择
          jdcheck: "", //京豆选择
          dqcheck: "", //东券选择
          jqcheck: "", //京券选择
          jfprice: "", //积分总共奖品数量
          jdprice: "", //京豆共奖品数量
          dqkey: "", //东券key
          dqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          dqprice: "", //面额
          dqday: "", //有效期
          jqkey: "", //京券key
          jqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          jqprice: "", //面额
          jqday: "", //有效期
          buttonText: "", //确定按钮
          jumpLink: "", //跳转链接
          jqkeyInspect: false,
          dqkeyInspect: false,
          jfshow: false,
          jdshow: false,
          dqshow: false,
          jqshow: false,
        },
        {
          sceneType: "",
          peopleModels: "",
          giftTemplateId: "",
          templateUrlimg: "", // 礼包模板图
          sendCount: "",
          jfcheck: "", //积分选择
          jdcheck: "", //京豆选择
          dqcheck: "", //东券选择
          jqcheck: "", //京券选择
          jfprice: "", //积分总共奖品数量
          jdprice: "", //京豆共奖品数量
          dqkey: "", //东券key
          dqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          dqprice: "", //面额
          dqday: "", //有效期
          jqkey: "", //京券key
          jqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          jqprice: "", //面额
          jqday: "", //有效期
          buttonText: "", //确定按钮
          jumpLink: "", //跳转链接
          jqkeyInspect: false,
          dqkeyInspect: false,
          jfshow: false,
          jdshow: false,
          dqshow: false,
          jqshow: false,
        },
        {
          sceneType: "",
          peopleModels: "",
          giftTemplateId: "",
          templateUrlimg: "", // 礼包模板图
          sendCount: "",
          jfcheck: "", //积分选择
          jdcheck: "", //京豆选择
          dqcheck: "", //东券选择
          jqcheck: "", //京券选择
          jfprice: "", //积分总共奖品数量
          jdprice: "", //京豆共奖品数量
          dqkey: "", //东券key
          dqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          dqprice: "", //面额
          dqday: "", //有效期
          jqkey: "", //京券key
          jqquota: "", //满足优惠的消费金额 ；例满100减1的东券，此处填写100
          jqprice: "", //面额
          jqday: "", //有效期
          buttonText: "", //确定按钮
          jumpLink: "", //跳转链接
          jqkeyInspect: false,
          dqkeyInspect: false,
          jfshow: false,
          jdshow: false,
          dqshow: false,
          jqshow: false,
        },
      ];
      this.$emit("titopName", this.activityData.name, false);
    },
    //重新选择模板
    handleChoice(item) {
      console.log(item, 2222);
      if (item) {
        // 1 店铺积分  2 京豆  3  京券  4  东券
        const giftTemplatePrizeType = item.prizeType.split(",");
        this.sceneList[this.crowIndex].jfshow = false;
        this.sceneList[this.crowIndex].jdshow = false;
        this.sceneList[this.crowIndex].jqshow = false;
        this.sceneList[this.crowIndex].dqshow = false;
        giftTemplatePrizeType.forEach((query) => {
          if (query == 1) {
            this.sceneList[this.crowIndex].jfshow = true;
          }
          if (query == 2) {
            this.sceneList[this.crowIndex].jdshow = true;
          }
          if (query == 3) {
            this.sceneList[this.crowIndex].jqshow = true;
          }
          if (query == 4) {
            this.sceneList[this.crowIndex].dqshow = true;
          }
        });
        // this.sceneList[this.crowIndex].templateNum = giftTemplatePrizeType.length;
        this.sceneList[this.crowIndex].templateNum = item.awardNumLimit; //Tag:礼包模板配置优化
        this.sceneList[this.crowIndex].giftPrizeType = item.giftPrizeType;
        this.sceneList[this.crowIndex].templateUrlimg = item.templateUrl;
        this.sceneList[this.crowIndex].customPicUrl = item.templateUrl;
        this.sceneList[this.crowIndex].giftTemplateId = item.id;
        this.sceneList[this.crowIndex].awardNumLimit = item.awardNumLimit;
        this.sceneList[this.crowIndex].jfcheck = false;
        this.sceneList[this.crowIndex].jdcheck = false;
        this.sceneList[this.crowIndex].jqcheck = false;
        this.sceneList[this.crowIndex].dqcheck = false;
      }
      this.giftPopup = false;
    },
    //更换图片前校验
    beforeUploadUrl(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        const valid = (image.width == 630 && image.height == 788)
        file.isFlag = valid
        _this.uploadSize = valid
        if(valid){
        }else{
          _this.$message.info('图片宽高不符合要求,请重新上传')
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      const isLt1M = file.size < 1024 * 1024;
      
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg",".jpeg",".gif"]
      if (!isLt1M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 更换图片成功
    handleUploadUrl(res){
      if(res.code != 1){
        this.$message.error(res.messaga);
      }else{
        if(this.uploadSize){
          this.sceneList[this.crowIndex].customPicUrl = res.data;
        }
      }
    },
    // 重置图片
    resetUrl() {
      if(this.activeValue) {
        this.sceneList[this.crowIndex].customPicUrl = this.sceneList[this.crowIndex].templateUrlimg
      } else {
        this.sceneList[this.crowIndex].customPicUrl = this.copyImg;
      }
    },
    // tab切换
    handleClickTabs(val) {
      // console.log(val);
      this.crowIndex = val.index;
      // console.log(val.name.end());
      // this.personLabCrow = [item]
    },
    //礼包奖项 输入框限制负数
    scenariobCheckputn(e, num = "2") {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
      if (num == "1") {
        if (e.target.value > 90) {
          e.target.value = "";
          this.$message.warning("有效时间为1-90天");
        }
      }
      return e.target.value
    },
    // 充值京豆
    jumpJingduo() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
      });
      window.open(routeUrl.href, "_blank");
    },
    handleInspect(num) {
      // 1为东券 2为京券
      if (num === "1") {
        console.log(1111);
        this.sceneList[this.crowIndex].dqkeyInspect = true;
        // 检测putKey可用性
        byPutKey(this.sceneList[this.crowIndex].dqkey).then((res) => {
          console.log(res);
          // if (res.code == 1) {
          //   this.setFormList.endTime = res.data.endTime;
          //   this.setFormList.startTime = res.data.beginTime;
          //   this.setFormList.takeBeginTime = res.data.activityBeginTime;
          //   this.setFormList.takeEndTime = res.data.activityEndTime;
          //   this.setFormList.name = res.data.couponTitle;
          //   this.setFormList.discount = res.data.discount;
          //   this.setFormList.quota = res.data.quota;
          //   this.quota = res.data.quota;
          //   if (res.data.quota) {
          //     this.resource = "订单满";
          //   } else {
          //     this.resource = "无条件";
          //   }
          //   this.TimeSendTimeOne();
          //   this.TimeSendTimeTwo();
          //   this.$message.success("成功");
          // } else {
          //   this.$message.error(res.data.message);
          // }
        });
      } else {
        this.sceneList[this.crowIndex].jqkeyInspect = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navTab {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
  position: relative;
  height: 50px;
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #f6f6f6;
  span {
    height: 50px;
    line-height: 50px;
    position: relative;
    padding: 0 11px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .active {
    color: #7b61ff;
    &::before {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 80%;
      height: 2px;
      background-color: #7b61ff;
      transition: all 0.2s;
      animation: opation 0.2s;
    }
    @keyframes opation {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 100%;
      }
    }
  }
}
.crowdAction {
  border-top: 2px solid #7b61ff;
}

.zhuyi {
  margin-left: 18px;
  padding-left: 20px;
  background: url("../../assets/images/new_icon_reminder.png") no-repeat;
  background-position-y: 3px;
  background-size: 14px 14px;
}
.notes {
  line-height: 20px;
  background-position-y: 8px;
  padding-top: 5px !important;
}
.overHiddle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 2px;
  width: 96%;
  border: none;
  text-align: left;
  display: inline-block;
  margin-left: -8px;
  &:hover,
  &:focus {
    color: #666;
    background: #fff;
  }
}
.orangeColor {
  color: #7b61ff;
}
.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
//
.wrapperBg {
  // background: url("../../assets/images/integralCenter/tcdt.png") no-repeat;
  background-color: #666 !important;
}
.giftBottom {
  position: absolute;
  bottom: 19%;
  left: 50%;
  transform: translateX(-50%);
  // background: red;
  width: 112px;
  height: 24px;
  display: block;
  text-align: center;
  line-height: 24px;
  color: red;
  opacity: 0.7;
  font-weight: 600;
}
.giftContent {
  position: absolute;
  bottom: 30%;
  left: 50%;
  transform: translateX(-50%);
  // background: blue;
  width: 112px;
  text-align: center;
  line-height: 15px;
  color: #ffdfa4;
  opacity: 0.8;
}
.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.shopSet {
  // width: 100%;
  display: flex;
  margin-top: 20px;
  &-left {
    // width: 100%;
    .shopSetLeft-connet {
      width: 740px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .inner {
        // margin-top: 20px;
        // width: 420px;
        width: 360px;
        min-height: 214px;
        background: #ffffff;
        border: 1px solid #f5f5f5;
        border-radius: 8px;
        cursor: pointer;
        position: relative;
        margin-bottom: 20px;
        padding-bottom: 10px;
        .innerTap {
          width: 100%;
          height: 50px;
          line-height: 50px;
          padding: 0 12px;
          background: #f5f5f5;
          border-radius: 8px 8px 0px 0px;
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: space-between;
          .logoImg {
            position: absolute;
            top: 0px;
            width: 16px;
            height: 16px;
            display: inline-block;
          }
          .innerTap-name {
            display: inline-flex;
            width: 186px;
            height: 26px;
            // line-height: 26px;
            padding-left: 19px;
            align-items: center;
          }
          .innerTap-bottom {
            display: inline-block;
            width: 60px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            background: #d5d8de;
            border-radius: 4px;
            color: #fff;
            margin-right: 20px;
          }
        }
        .innerTip {
          width: 100%;
          // height: 100px;
          // line-height: 100px;
          // text-align: center;
          font-size: 14px;
          // font-weight: 500;
          color: #333333;
          padding: 20px 0 0 0;
          .innerTip-content {
            color: #333;
            display: flex;
            margin-bottom: 10px;
            padding: 0 18px;
            a {
              color: #7b61ff;
              // text-decoration: underline;
            }
          }
          .innerTip-content-name {
            font-size: 14px;
          }
          .innerTip-content-input {
            width: 68%;
            display: flex;
            span {
              width: 28%;
              display: block;
              padding-left: 5px;
            }
          }
          .innerTipback {
            // background: red;
            width: 100%;
            // padding: 0 -13px;
            height: 80px;
            flex-flow: wrap;
          }
        }
      }
    }
  }
  &-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    // padding-top: 20px;
    margin-top: -5px;
    margin-left: 100px;
    // width: 235px;
    width: 550px;
    &-btn {
      margin: 16px 0;
      display: flex;
      align-items: center;
    }
    &-tips {
      line-height: 18px;
      font-size: 14px;
      color: #999;
    }
  }
}
.shopDiaog {
  width: 60px;
  height: 26px;
  background: #ffffff;
  display: inline-block;
  line-height: 26px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #000;
  &:hover {
    border: 1px solid #7b61ff;
    color: #7b61ff;
  }
}
.tooltipBox {
  box-sizing: border-box;
  height: 485px;
  // width: 100%;
  // height: 100%;
  // background: red;
  // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
  padding: 30px;
  display: inline-flex;
  &-left {
    width: 253px;
    height: 417px;
    position: relative;
    margin-right: 30px;
    // .tooltipheis {
    //   width: 128px;
    //   height: 417px;
    //   position: absolute;
    //   border: 2px dashed #666666;
    //   top: 0px;
    //   left: -50%;
    // }
    .tooltipBoder {
      width: 184px;
      height: 273px;
      position: absolute;
      border: 2px dashed #2fd461;
      top: 50%;
      left: 46%;
      transform: translate(-50%, -50%);
      border-radius: 4px;
      &::after {
        content: "";
        width: 53px;
        border-top: 2px dashed #2fd461;
        display: block;
        position: absolute;
        right: -55px;
        top: 25px;
      }

      &::before {
        content: "";
        width: 16px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -63px;
        top: 88px;
      }
    }
    .tooltipliji {
      position: absolute;
      bottom: 80px;
      left: 47%;
      transform: translateX(-50%);
      width: 154px;
      height: 42px;
      border: 2px dashed #75baff;
      border-radius: 4px;
      &::before {
        content: "";
        width: 50px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -55px;
        top: 19px;
      }
      &::after {
        content: "";
        height: 150px;
        border-right: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -60px;
        top: -131px;
      }
    }
  }
  &-right {
    width: 368px;
    height: 100%;
    .p1 {
      font-size: 15px;
      font-weight: 500;
      line-height: 21px;
      color: #333333;
    }
    .p2 {
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      color: #666666;
    }
  }
}
.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.crowd {
  // padding-left: 50px;
  padding-left: 140px;
  margin-bottom: 20px;
  &-point {
    color: #999999;
    margin-bottom: 8px;
    position: relative;
    padding-left: 8px;
    // display: flex;
    margin-bottom: 20px;
    // &::before {
    //   position: absolute;
    //   top: 0px;
    //   left: 0px;
    //   width: 3px;
    //   height: 14px;
    //   background: #7B61FF;
    //   border-radius: 3px;
    //   content: "";
    //   display: block;
    // }
    /deep/.el-tabs__item {
      padding-left: 0px !important;
      padding-right: 0 !important;
    }
    .crowd-point-rq {
      padding-left: 15px;
      padding-right: 15px;
      // display: flex;
      // margin-right: 20px;
      // .crowd-point-content{
      //   border: 1px solid red;
      //   padding: 0 10px;
      //   cursor: pointer;
      //   margin-left: 10px;
      //   // background: #7B61FF;
      //   color:#000;
      // }
    }
  }

  &-tab {
    width: 100%;
    &-head {
      width: 100%;
      height: 48px;
      padding-left: 30px;
      background: #fafafa;
    }
    &-sm {
      display: inline-block;
      width: 87%;
      color: #666;
      // line-height: 48px;
      position: relative;
    }
    &-name {
      display: inline-block;
      width: 13%;
      line-height: 48px;
    }
    &-middle {
      padding-left: 30px;
      border: 1px solid #f0f0f0;
      border-left: none;
      border-right: none;
      border-bottom: none;
      display: flex;
    }
    .descbox {
      // top: -8px;
      display: flex;
      justify-items: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .dx {
      // position: absolute;
      // top: 19px;
      width: 100%;
    }
    .nameAlign {
      display: flex;
      height: 48px;
      align-items: center;
    }
  }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    width: 90px;
    background: url("../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #7b61ff;
  }
  color: #999;
}

.flex {
  display: flex;
  align-items: center;
}
.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 520px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  // margin-top: 20px;
  margin: -24px;
  margin-bottom: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 0px 35px 0;
    .tishi {
      // height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      background: #fffaee;
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 14px 20px;
    }
    .itemList {
      display: flex;
      .item {
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          // width: 100%;
          height: 100%;
          width: 253px;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #7b61ff;
            border-bottom: 1px solid #7b61ff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #7b61ff;
            border-left: 1px solid #7b61ff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper-kaika {
          width: 100%;
          height: 100%;
          display: grid;
          // align-items: center;
          // justify-content: center;

          &-img {
            background-color: #fafafa;
            border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
            border-radius: 8px;
            height: 350px;
            // margin-right: 20px;
            position: relative;
            &:hover {
              .borderkaika::before,
              .borderkaika::after {
                opacity: 1;
                transform: scale(1);
              }
            }
            .borderkaika {
              position: absolute;
              left: -6px;
              top: -6px;
              width: 218px;
              height: 360px;
              border-radius: 4px;
              &::before,
              &::after {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                content: "";
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.8s, transform 0.8s;
                border-radius: 4px;
              }
              &::before {
                border-top: 1px solid #7b61ff;
                border-bottom: 1px solid #7b61ff;
                -webkit-transform: scale(0, 1);
                transform: scale(0, 1);
              }
              &::after {
                border-right: 1px solid #7b61ff;
                border-left: 1px solid #7b61ff;
                -webkit-transform: scale(1, 0);
                transform: scale(1, 0);
              }
            }

            div {
              font-size: 18px;
              font-weight: bold;
              // line-height: 25px;
              color: #333333;
            }
            img {
              width: 32px;
              height: 32px;
            }

            .queryIdIMG {
              display: none;
            }
            &:hover {
              .queryIdIMG {
                display: block;
              }
              .mask {
                opacity: 1;
              }
            }
            .mask {
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              background-color: rgba(0, 0, 0, 0.6);
              color: #fff;
              opacity: 0;
              transition: all 0.2s;
              height: 92.5%;
              .img {
                max-width: 130px;
                margin: 0 auto 30px;
                .imgBg {
                  box-sizing: border-box;
                  height: 129px;
                  width: 129px;
                  padding: 6px;
                  border-radius: 6px;
                  background-color: #fff;
                }
                .tpl {
                  display: inline-block;
                  font-size: 14px;
                  color: #fff;
                  margin-top: 10px;
                  // opacity: 0.7;
                }
              }
              .mask-gift {
                position: absolute;
                bottom: 3px;
                width: 100%;
                div {
                  text-align: center;
                  color: #ffffff !important;
                  font-size: 12px !important;
                  opacity: 0.7;
                  font-weight: 500 !important;
                  line-height: 19px;
                }
              }
            }
          }
          &-tanchuang {
            position: absolute;
            // top: 50%;
            top: 35%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          &-bottom {
            width: 102%;
            height: 30px;
            background: #ffffff;
            border: 1px solid #e7e7e7;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            color: #666 !important;
            position: absolute;
            bottom: -4px;
            left: -2px;
            line-height: 30px;
            font-size: 14px !important;
            text-align: left;
            padding-left: 10px;
            font-weight: 500 !important;
          }
          .lijijq {
            &::after {
              content: "立即领取";
              display: block;
              position: absolute;
              bottom: 9px;
              left: 51%;
              transform: translateX(-50%);
              font-size: 14px;
              font-family: system-ui;
              font-weight: bold;
              color: #ed6e09;
              text-shadow: 0 0 black;
            }
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          display: grid;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            width: 240px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    // min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url(../../assets/images/integralCenter/yhq.png);
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #7b61ff;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .returnBtn {
      width: 148px;
      background: rgba(123, 97, 255, 0.1);
      border: 1px solid #7b61ff;
      color: #7b61ff;
      transition: all 0.2s;
      &:hover {
        background-color: #7b61ff;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #7b61ff;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }

  .wrapper-kaika-img {
    width: 210px;
    height: 374px;
    margin-bottom: 40px;
  }
}
@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (min-width: 1900px) {
  .wrapper-kaika {
    grid-template-columns: repeat(7, 1fr);
  }
}
</style>

<style lang="scss">
.createPlayStep {
  // .el-step.is-horizontal .el-step__line {
  //   height: 1px;
  // }
  // .el-step__head.is-success {
  //   color: #7B61FF;
  //   border-color: #7B61FF;
  //   .el-step__line {
  //     background-color: #7B61FF;
  //   }
  // }
  // .el-step__head.is-process {
  //   color: #7B61FF;
  //   border-color: #7B61FF;
  // }
  // .el-step__title.is-process {
  //   color: #7B61FF;
  // }
  // .el-step__title.is-success {
  //   color: #7B61FF;
  // }
  .textareabox {
    .el-textarea__inner {
      min-height: 80px !important;
    }
  }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.tooplitMax {
  max-width: 1000px !important;
}
</style>
